import type { Task, TaskInput, TaskPatch } from '@platform/api-client';
import type { ZoneShift } from '../calendar/zones';

export const TASK_GROUPS = ['overdue', 'today', 'week', 'later', 'noDate', 'completed'] as const;
export type TaskGroup = typeof TASK_GROUPS[number];
export const dateKey = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const wallValue = (date: Date) => `${dateKey(date)}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
export const taskComplete = (task: Pick<Task, 'status' | 'percent'>) => task.status === 'Completed' || task.percent === 100;
export function taskGroup(task: Task, today: string, endOfWeek: string): TaskGroup {
  if (taskComplete(task)) return 'completed';
  if (!task.due) return 'noDate'; if (task.due < today) return 'overdue'; if (task.due === today) return 'today';
  return task.due < endOfWeek ? 'week' : 'later';
}
export const taskDefaults = (subject: string): TaskInput => ({ subject, status: 'NotStarted', percent: 0, start: null, due: null, reminder: null, importance: 'Normal', categories: [], notes: '', sensitivity: 'Normal' });
export function taskChanges(current: Task, draft: TaskInput): TaskPatch {
  const fields = ['subject', 'status', 'percent', 'start', 'due', 'reminder', 'importance', 'categories', 'notes', 'sensitivity'] as const;
  const changed = Object.fromEntries(fields.filter(key => JSON.stringify(current[key]) !== JSON.stringify(draft[key])).map(key => [key, draft[key]]));
  return { ...changed, changeKey: current.changeKey };
}
export function reminderInstant(value: string, zone: ZoneShift): string | null {
  if (!value) return null;
  const wall = new Date(value); if (!Number.isFinite(wall.getTime())) throw new Error('Invalid reminder time');
  const instant = zone.fromWall(wall);
  if (wallValue(zone.toWall(instant)) !== value.slice(0, 16)) throw new Error('Nonexistent reminder wall time');
  return instant.toISOString();
}
